import React from 'react'
import classNames from 'classnames'
import styles from './avatar.module.scss'

interface Props {
  title: string
  image: string
  square?: boolean
  rounded?: boolean
}

export const Avatar: React.FC<Props> = ({
  title,
  image,
  square = false,
  rounded = true
}) => {
  return (
    <div className={styles.container}>
      <img
        width={41}
        height={41}
        src={image}
        alt={title}
        className={classNames(styles.image, {
          [styles.rounded]: rounded,
          [styles.square]: square
        })}
      />
      <p className={styles.title}>{title}</p>
    </div>
  )
}
